module.exports = __webpack_public_path__ + "static/media/gladys1.085343c5.mp3";